
import './App.css';
import  {Navbar}  from './components/Navbar/Navbar';
import {BrowserRouter , Routes,Route} from 'react-router-dom';
import ShopCategory from './pages/ShopCategory';
import Shop from'./pages/Shop';
import Cart from './pages/Cart';
import Product from './pages/Product';
import LoginSign from './pages/LoginSign';
import Footer from './components/Footer/Footer';
import men_banner from './components/Assets/banner_mens.png'
import women_banner from './components/Assets/banner_women.png'
import kid_banner from './components/Assets/banner_kids.png'
import Checkout from './pages/Checkout';

function App() {
  return (
    <div >
      <BrowserRouter>
      <Navbar/>
      <Routes>
        <Route path='/' element= {<Shop/>}/>
        <Route path='/mens' element= {<ShopCategory banner= {men_banner} category= "men"/>}/>
        <Route path='/womens' element= {<ShopCategory banner ={women_banner} category= "women"/>}/>
        <Route path='/kids' element= {<ShopCategory banner = {kid_banner} category= "kid"/>}/>
        <Route path="/product" element ={<Product/>}>
        <Route path= ':productId' element ={<Product/>}/>

        </Route>
        <Route path='/cart' element= {<Cart/>}/>
        <Route path='/checkout' element = {<Checkout/>}/>
        <Route path='/login' element= {<LoginSign/>}/>

      </Routes>
      <Footer/>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
